module.exports = __webpack_public_path__ + "413ac035408f064aa86c100a47f7c19a.pdf";